if (!window.Eurus.loadedScript.has('variant-select-card.js')) {
  window.Eurus.loadedScript.add('variant-select-card.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelectCard', (
        element,
        sectionId,
        productId,
        productUrl,
        customizableChooseOption,
        chooseOption,
        productBundle,
        pageParam,
        chooseOptionLabel,
        addToCartLabel,
        handleSectionId
      ) => ({
        loadingEls: '',
        currentVariant: {},
        cachedResults: [],
        selectionError: false,
        lastTarget: productUrl,
        requestVersion: 0,
        requestKey: `eurus:product_card_request:${sectionId}:${window.Eurus.cardRequestInstance = (window.Eurus.cardRequestInstance || 0) + 1}`,
        _scheduleRender(callback) {
          const version = this.requestVersion;
          window.requestAnimationFrame(() => {
            if (version === this.requestVersion) callback();
          });
        },
        _inlineCard() {
          return element.hasAttribute('data-inline-card-picker') ? element.closest('[data-inline-product-card]') : null;
        },
        _setInlineState(state, status = '') {
          const card = this._inlineCard();
          if (!card) return;
          card.dataset.variantState = state;
          card.setAttribute('aria-busy', state === 'pending' ? 'true' : 'false');
          const showStatusLabel = state === 'unavailable' && status !== '';
          card.querySelectorAll('[data-inline-card-atc]').forEach(button => {
            button.disabled = state !== 'ready';
            this._setCardButtonLabel(button, showStatusLabel ? status : '');
          });
          card.querySelectorAll('.card-product-inline-form input[name="id"]').forEach(input => { input.disabled = state !== 'ready'; });
          card.querySelectorAll('[data-inline-card-status]').forEach(el => { el.textContent = showStatusLabel ? '' : status; });
          this.selectionError = state === 'error';
          element.querySelector('card-compact-picker')?.sync();
        },
        _setCardButtonLabel(button, override) {
          const labels = button.querySelectorAll('.button-text');
          if (!labels.length) return;
          if (override) {
            if (!button.dataset.defaultLabel) button.dataset.defaultLabel = labels[0].textContent.trim();
            labels.forEach(el => { el.textContent = override; });
            button.setAttribute('aria-label', override);
          } else if (button.dataset.defaultLabel) {
            labels.forEach(el => { el.textContent = button.dataset.defaultLabel; });
            button.setAttribute('aria-label', button.dataset.defaultLabel);
            delete button.dataset.defaultLabel;
          }
        },
        async _renderInlineProductCard(url, optionNum) {
          const version = ++this.requestVersion;
          this.lastTarget = url || element.dataset.url;
          this._setInlineState('pending');
          const selected = this._getSelectedOptionValues();
          if (selected.length < Number(optionNum) && element.dataset.defaultVariant !== 'true') {
            this.loadingEls = '';
            this._setInlineState('unavailable');
            return;
          }
          const targetUrl = new URL(this.lastTarget, window.location.origin);
          const combined = targetUrl.pathname !== new URL(element.dataset.url, window.location.origin).pathname;
          targetUrl.searchParams.set('section_id', combined ? handleSectionId : 'card-product');
          if (combined) targetUrl.searchParams.set('page', pageParam);
          else if (element.dataset.defaultVariant === 'true') {
            targetUrl.searchParams.delete('option_values');
            targetUrl.searchParams.set('variant', element.dataset.variantId);
          } else {
            targetUrl.searchParams.delete('variant');
            targetUrl.searchParams.set('option_values', selected.join(','));
          }
          const link = targetUrl.pathname + targetUrl.search;
          const helper = Alpine.store('xHelper');
          helper.cancelRequest(this.requestKey);
          const controller = new AbortController();
          helper.requestControllers.set(this.requestKey, controller);
          try {
            let responseText = this.cachedResults[link];
            if (!responseText) {
              responseText = await window.Eurus.productCardRefresh.load(link, productId, controller.signal);
            }
            if (version !== this.requestVersion || !element.isConnected) return false;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            if (combined) {
              const replacement = html.getElementById(`card-product-clone-${handleSectionId}`);
              const replacementCard = replacement?.querySelector('[data-inline-product-card]');
              if (!replacementCard) throw new Error('Missing linked product card');
              const card = this._inlineCard();
              replacementCard.className = card.className;
              if (card.hasAttribute('x-slide-index')) replacementCard.setAttribute('x-slide-index', card.getAttribute('x-slide-index'));
              card.replaceWith(replacementCard);
              return true;
            }
            if (!html.querySelector('.x-variants-data-js script[type="application/json"]') || !html.querySelector('form button')) throw new Error('Incomplete variant response');
            this._getCurrentVariant(html);
            this._renderCardProductForm(html);
            this._renderCardProductOption(html);
            this._renderCardProductPrice(html);
            if (this.currentVariant) this._renderCardProductLabels(html);
            this._renderCardProductAvailabilityNotice(html);
            this._renderCardProductImage(html);
            const card = this._inlineCard();
            card.querySelectorAll('a.link-product-variant').forEach(linkEl => {
              const target = new URL(linkEl.href, window.location.origin);
              if (this.currentVariant) target.searchParams.set('variant', this.currentVariant.id);
              else target.searchParams.delete('variant');
              linkEl.href = target.toString();
            });
            const button = html.querySelector('form button');
            this._setInlineState(this.currentVariant?.available && !button.disabled ? 'ready' : 'unavailable', button.dataset.cardStatus || '');
            this.cachedResults[link] = responseText;
            this._dispatchUpdateVariant(html);
            document.dispatchEvent(new CustomEvent('eurus:variant:change', { detail: { variant: this.currentVariant } }));
            return true;
          } catch (error) {
            if (version === this.requestVersion && element.isConnected) {
              this._setInlineState('error');
              if (error.name !== 'AbortError') console.error(error);
            }
            return false;
          } finally {
            if (version === this.requestVersion) {
              this.loadingEls = '';
              if (helper.requestControllers.get(this.requestKey) === controller) helper.requestControllers.delete(this.requestKey);
            }
          }
        },
        init() {
          if (this._inlineCard()) {
            this.unregisterRefresh = window.Eurus.productCardRefresh.register(this._inlineCard(), productId, {
              invalidate: () => {
                this.cachedResults = [];
                ++this.requestVersion;
                Alpine.store('xHelper').cancelRequest(this.requestKey);
              },
              refresh: () => this._renderInlineProductCard(element.dataset.url, 0)
            });
            return;
          }
          this.onClear = () => {
            this.cachedResults = [];
            this._reloadCardProduct();
          };
          document.addEventListener(`eurus:product-card:clear:${productId}`, this.onClear);
        },
        destroy() {
          this.unregisterRefresh?.();
          ++this.requestVersion;
          Alpine.store('xHelper').cancelRequest(this.requestKey);
          Alpine.store('xHelper').requestControllers.delete(this.requestKey);
          document.removeEventListener(`eurus:product-card:clear:${productId}`, this.onClear);
        },
        _dispatchUpdateVariant(html="") {
          this._scheduleRender(() => {
            setTimeout(() => { this.loadingEls = ''; }, 100);
          })
          document.dispatchEvent(new CustomEvent(`eurus:product-card-variant-select:updated:${sectionId}:${productUrl}`, {
            detail: {
              currentVariant: this.currentVariant,
              html: html
            }
          }));
        },
        _renderCardProductFormInput(formSrc, formDes) {
          const desInput = formDes.querySelectorAll('input');
          desInput?.forEach((input) => {
            if (input.name === 'quantity' && !formDes.classList.contains('card-product-inline-form')) return;
            if (input.name !== 'section-id' && input.name) {
              const src = formSrc.querySelector(`input[name=${CSS.escape(input.name)}]`);
              if (src) {
                input.value = src.value;
                input.checked = src.checked;
                input.disabled = src.disabled;
              }
            }
          });
        },
        _renderCardProductFormButton(formSrc, formDes) {
          const srcButton = formSrc.querySelector(`button`);
          if (srcButton) {
            const srcButtonText = srcButton.querySelector('.button-text');
            
            const desButton = formDes.querySelectorAll('button[type="submit"]');
            desButton.forEach((button) => {
              button.disabled = srcButton.disabled;
              if (button.hasAttribute('data-inline-card-atc')) return;
              button.ariaLabel = srcButton.ariaLabel;

              const desButtonText = button.querySelector('.button-text');
              if (srcButtonText && srcButtonText.textContent.trim() == chooseOptionLabel) {
                srcButtonText.textContent = addToCartLabel;
              }
              if (desButtonText && srcButtonText) {
                desButtonText.innerHTML = srcButtonText.innerHTML;
              }
            });
          }
        },
        _renderCardProductForm(html) {
          let target = chooseOption ? '.choose-options' : '.card-product'

          const formSrc = html.querySelector('form[id*="product-form-"]');
          let formDesAll = element.closest(target)?.querySelectorAll('form[id*="product-form-"]');
          if (formSrc && formDesAll) { 
            formDesAll.forEach(formDes => {
              this._renderCardProductFormInput(formSrc, formDes);
              this._renderCardProductFormButton(formSrc, formDes);
            });
          }
        },
        _renderCardProductCurrentVariant(optionSrc, optionDes) {
          const currentVariantSrc = optionSrc.querySelector('.current-variant');
          const currentVariantDes = optionDes.querySelector('.current-variant');

          if (currentVariantSrc && currentVariantDes) {
            currentVariantDes.innerHTML = currentVariantSrc.innerHTML;
          }
        },
        _renderCardProductInputs(optionSrc, optionDes) {
          const inputsSrc = optionSrc.querySelectorAll('input');
          const inputsDes = optionDes.querySelectorAll('input');

          inputsDes?.forEach(des => {
            const src = Array.from(inputsSrc).find((inputSrc) => inputSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              if (src.classList.contains('disabled')) {
                des.classList.add('disabled');
              } else {
                des.classList.remove('disabled');
              }
              des.checked = src.checked;
              des.dataset.available = src.dataset.available;
              if (src.hasAttribute('aria-label')) des.setAttribute('aria-label', src.getAttribute('aria-label'));
            }
          });
        },
        _renderCardProductOptions(optionSrc, optionDes) {
          const optionsSrc = optionSrc.querySelectorAll('option');
          const optionsDes = optionDes.querySelectorAll('option');

          optionsDes?.forEach(des => {
            const src = Array.from(optionsSrc).find((optionSrc) => optionSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              des.selected = src.selected;
              des.toggleAttribute('selected', src.selected);
              des.dataset.available = src.dataset.available;
              des.innerHTML = src.innerHTML;
            }
          });
        },
        _renderCardProductInputLabels(optionSrc, optionDes) {
          const labelsSrc = optionSrc.querySelectorAll('label');
          const labelsDes = optionDes.querySelectorAll('label');

          labelsDes?.forEach(des => {
            const src = Array.from(labelsSrc).find((labelSrc) => labelSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src) {
              if (src.hasAttribute('aria-label')) des.setAttribute('aria-label', src.getAttribute('aria-label'));
              if (des.style.getPropertyValue('--bg-image').trim() !== '') {
                des.style.setProperty('--bg-image', src.style.getPropertyValue('--bg-image'));
              }
              if (des.style.getPropertyValue('--ratio-image').trim() !== '') {
                des.style.setProperty('--ratio-image', src.style.getPropertyValue('--ratio-image'));
              }
            }
          });
        },
        _renderCardProductValueVariant(optionSrc, optionDes) {
          const scriptsSrc = optionSrc.querySelectorAll('script[type="application/json"][data-option-value-id]');
          const scriptsDes = optionDes.querySelectorAll('script[type="application/json"][data-option-value-id]');

          scriptsDes?.forEach(des => {
            const src = Array.from(scriptsSrc).find((scriptSrc) => scriptSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              des.textContent = src.textContent;
            }
          })
        },
        _renderCardProductOption(html) {
          const optionSrc = html.querySelector('.x-variants-data-js');
          const optionDes = element.closest('.x-variants-data-js');

          if (optionSrc && optionDes) {
            this._renderCardProductCurrentVariant(optionSrc, optionDes);
            this._renderCardProductInputs(optionSrc, optionDes);
            this._renderCardProductOptions(optionSrc, optionDes);
            this._renderCardProductInputLabels(optionSrc, optionDes);
            this._renderCardProductValueVariant(optionSrc, optionDes);
          }
        },
        _renderCardProductPrice(html) {
          let target = chooseOption ? '.choose-options' : '.card-product'

          const priceSrc = html.querySelector((this._inlineCard() || chooseOption || productBundle) ? '.x-card-price .choose-option-price' : '.x-card-price .product-card-price');
          const priceDes = element.closest(target).querySelector('.x-card-price');
          if (!priceDes) return;
          if (this.currentVariant == null) {
            priceDes.classList.add('hidden');
            return;
          } else {
            priceDes.classList.remove('hidden');
          }

          const priceRange = priceDes.querySelector('.price-range');
          if (priceSrc && priceDes) {
            priceDes.innerHTML = priceSrc.innerHTML;
            if (priceRange) {
              const priceEl = priceDes.querySelector('.price');
              if (priceEl) {
                priceEl.innerHTML += priceRange.outerHTML;
                const altData = priceDes.querySelector('[data-card-image-alt]');
                const rangeText = priceRange.querySelector('.break-all')?.textContent.trim();
                if (altData && rangeText) altData.dataset.cardImageAlt += ' ' + rangeText;
              }
            }
            const imageAlt = priceDes.querySelector('[data-card-image-alt]')?.dataset.cardImageAlt;
            if (imageAlt) {
              element.closest('.card-product')?.querySelectorAll('[data-card-product-image][data-card-image-alt-source="fallback"]').forEach(image => image.setAttribute('alt', imageAlt));
            }
          }
        },
        _renderCardProductLabels(html) {
          const labelDataSrc = html.querySelector('.x-labels-data');
          const labelDataDes = element.closest('.card-product').querySelector('.x-labels-data');

          if (labelDataSrc && labelDataDes) {
            labelDataDes.setAttribute('x-labels-data', labelDataSrc.getAttribute('x-labels-data'));
            this.$nextTick(() => {
              Alpine.store('xBadges') && Alpine.store('xBadges').load(labelDataDes, () => {}, null, true);
            });
          }
        },
        _renderCardProductAvailabilityNotice(html) {
          const noticeSrc = html.getElementById('x-availability-notice');
          const noticeDes = element.closest('.card-product').querySelector('div[id*="x-availability-notice"]');

          if (noticeSrc && noticeDes) {
            noticeDes.innerHTML = noticeSrc.innerHTML;
          }
        },
        _renderCardProductImage(html) {
          const variantImage = html.getElementById('x-variant-image');
          const variantImageSrc = variantImage?.dataset.imageUrl || '';
          const cardProduct = element.closest('.card-product');
          if (variantImageSrc != '') {
            let media = cardProduct.querySelector(`[media="${variantImageSrc}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide) {
                if (slide.splide) {
                  slide.splide.go(Number(index));
                } else {
                  document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
                    slide.splide.go(Number(index));
                  });
                }
                return;
              } 
            }
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) return;
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", variantImageSrc);
            previewImg.setAttribute('alt', variantImage.getAttribute('alt') || '');
            previewImg.dataset.cardImageAltSource = variantImage.dataset.cardImageAltSource || 'fallback';
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          } else {
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          }
        },
        _renderLinkedProductInput() {
          const container = element.closest('.x-product-data-container');
          let desInput =
            container?.querySelector('input[name="properties[_linked_product_id][]"]') ||
            container?.querySelector('input[name="properties[_linked_product_id_qty][]"]');
          
          if (desInput) {
            if (this.currentVariant?.available) {
              desInput.value = this.currentVariant.id;
              desInput.disabled = false;
            } else {
              desInput.value = "";
              desInput.disabled = true;
            }
            desInput.classList.remove('customization-picker','validate-checkbox', 'required-picker');
          }
        },
        _renderCurrentOptionText(html) {
          const desSelectedValueText = element.closest('.x-product-data-container')?.querySelectorAll('.option-selected-value');
          const srcSelectedValueText = html.querySelectorAll('.option-selected-value');

          desSelectedValueText?.forEach(des => {
            const src = Array.from(srcSelectedValueText).find((srcText) => srcText.dataset.optionName == des.dataset.optionName);
            if (src && des) {
              des.classList.remove('hidden');
              des.innerHTML = src.innerHTML;
            }
          });
        },
        _renderCustomizableOptionSelectedVariant() {
          const desSelectedVariantText = element.closest('fieldset:has(.x-product-data-container)').querySelector('.selected-variant-name');
          if (desSelectedVariantText) {
            desSelectedVariantText.textContent = `: ${this.currentVariant.name}`;
          }
        },
        _renderCustomizableOptionPriceText(html) {
          const desVariantPriceText = element.closest('fieldset:has(.x-product-data-container)').querySelector(`.variant-price-${productId}`);
          const srcVariantPriceText = html.querySelector(`.variant-price-${productId}`);
          if (desVariantPriceText && srcVariantPriceText) {
            desVariantPriceText.innerHTML = `+ ${srcVariantPriceText.innerHTML}`;
          }
        },
        _getCurrentVariant(html) {
          this.currentVariant = JSON.parse(html.querySelector('.x-variants-data-js script[type="application/json"]')?.textContent);
        },
        _getCurrentVariantCbl(html) {
          this.currentVariant = JSON.parse(html.querySelector(`${chooseOption ? '#choose-options-content' : '.product-card-cbl-clone'} script[type="application/json"]`)?.textContent)
        },
        updateProductCard(optionNum, target, isByob) {
          if (this._inlineCard()) return this._renderInlineProductCard(target || element.dataset.url, optionNum);
          let callback = () => {};

          const isCbl = target && target !== element.dataset.url;
          const targetUrl = isCbl ? target : element.dataset.url;

          if (isCbl) {
            callback = (html) => {
              this._scheduleRender(() => {
                this._getCurrentVariantCbl(html);
                this._replaceProductCardCbl(html);
                this._dispatchUpdateVariant(html);
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
              });
            }
            this._renderProductCardCbl(targetUrl, callback);
            return;
          }

          if (chooseOption) {
            callback = (html) => {
              this._scheduleRender(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCurrentOptionText(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._dispatchUpdateVariant(html);
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
              });
            }
          } else if (customizableChooseOption) {
            callback = (html) => {
              this._scheduleRender(() => {
                this._getCurrentVariant(html);
                this._renderCardProductOption(html);
                this._renderLinkedProductInput();
                this._renderCurrentOptionText(html);
                this._renderCustomizableOptionSelectedVariant();
                this._renderCustomizableOptionPriceText(html);
                this._dispatchUpdateVariant(html);
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
              });
            }
          } else {
            callback = (html) => {
              this._scheduleRender(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLabels(html);
                this._renderCurrentOptionText(html);
                this._renderCardProductAvailabilityNotice(html);
                this._renderCardProductImage(html);
                this._dispatchUpdateVariant(html);
                document.dispatchEvent(new CustomEvent("eurus:variant:change", {
                  detail: {
                    variant: this.currentVariant
                  }
                }));
                
                if (isByob) {
                  document.dispatchEvent(new CustomEvent('eurus:product-card-update'));
                }
              });
            }
          }

          this._renderProductCard(targetUrl, optionNum, callback);
        },
        _reloadCardProduct() {
          let callback;
          let link = "";
          const selectedOptionValues = this._getSelectedOptionValues()
          let params = `option_values=${selectedOptionValues.join(',')}`;
          if (chooseOption || productBundle) {
            params = `option_values=${selectedOptionValues.join(',')}&page=${pageParam}`;
          }
          link = `${productUrl.split("?")[0]}?section_id=card-product&${params}`;
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            this.cachedResults[link] = '';
          }

          if (chooseOption) {
            callback = (html) => {
              this._scheduleRender(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCurrentOptionText(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._dispatchUpdateVariant(html);
              });
            }
          } else if (customizableChooseOption) {
            callback = (html) => {
              this._scheduleRender(() => {
                this._getCurrentVariant(html);
                this._renderCardProductOption(html);
                this._renderLinkedProductInput();
                this._renderCurrentOptionText(html);
                this._renderCustomizableOptionSelectedVariant();
                this._renderCustomizableOptionPriceText(html);
                this._dispatchUpdateVariant(html);
              });
            }
          } else {
            callback = (html) => {
              this._scheduleRender(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLabels(html);
                this._renderCardProductAvailabilityNotice(html);
                this._renderCardProductImage(html);
                this._dispatchUpdateVariant(html);
              });
            }
          }

          this._renderProductCard(productUrl, -1, callback);
        },
        _renderProductCard(url, optionNum, callback) {
          const version = ++this.requestVersion;
          let link = "";
          const selectedOptionValues = this._getSelectedOptionValues();
          if (optionNum !== -1) {
            if (selectedOptionValues.length < Number(optionNum)) {
              this._scheduleRender(() => {
                setTimeout(() => { this.loadingEls = ''; }, 100);
              });

              return
            };
          }
          if (selectedOptionValues.length === 0) return;
          let params = `option_values=${selectedOptionValues.join(',')}`;
          if (chooseOption || productBundle) {
            params = `option_values=${selectedOptionValues.join(',')}&page=${pageParam}`;
          }
          link = `${url.split("?")[0]}?section_id=card-product&${params}`;
          Alpine.store('xHelper').cancelRequest(this.requestKey);
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            const html = this.cachedResults[link];
            this._scheduleRender(() => {
              callback(html);
            });
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set(this.requestKey, controller);
            fetch(link, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                if (version !== this.requestVersion) return;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                this._scheduleRender(() => {
                  callback(html);
                });
                this.cachedResults[link] = html;
              }).catch(err => {
                if (version !== this.requestVersion) return;
                if (err.name !== 'AbortError') {
                  console.error(err);
                }
                this._scheduleRender(() => {
                  setTimeout(() => { this.loadingEls = ''; }, 100);
                })
              })
          }
        },
        _renderProductCardCbl(url, callback) {
          const version = ++this.requestVersion;
          let link = `${url}?section_id=${handleSectionId}&page=${pageParam}`;

          Alpine.store('xHelper').cancelRequest(this.requestKey);
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            const html = this.cachedResults[link];
            this._scheduleRender(() => {
              callback(html);
            });
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set(this.requestKey, controller);
            fetch(link, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                if (version !== this.requestVersion) return;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                this._scheduleRender(() => {
                  callback(html);
                });
                this.cachedResults[link] = html;
              }).catch(err => {
                if (version !== this.requestVersion) return;
                if (err.name !== 'AbortError') {
                  console.error(err);
                }
              })
          }
        },
        _replaceProductCardCbl(html) {
          let src, des;
          if (chooseOption) {
            src = html.querySelector('#choose-options-content .choose-options');
            des = element.closest(`.choose-options`);
          } else {
            src = html.getElementById(`card-product-clone-${handleSectionId}`);
            des = element.closest('.card-product');
          }

          if (src && des) {
            des.innerHTML = src.innerHTML;
          }
        },
        _getSelectedOptionValues() {
          return Array.from(element.querySelectorAll('select option:checked[value], fieldset input:checked')).map(
            (e) => e.dataset.optionValueId
          );
        }
      }))
    });
  });
}
